import { Link, useLocation, useNavigate } from "react-router-dom";
import { User, LogOut, FileText, MessageSquare, ScanLine, ShoppingCart, Tag, Truck } from "lucide-react";
import { usePortalAuth } from "../../hooks/usePortalAuth";

/** Raccourcis permanents vers les espaces les plus consultés du portail. */
const NAV_LINKS = [
  { to: "/orders", label: "Commandes", icon: ShoppingCart },
  { to: "/invoices", label: "Factures", icon: FileText },
  { to: "/delivery-notes", label: "Livraisons", icon: Truck },
  { to: "/prices", label: "Tarifs", icon: Tag },
  { to: "/messages", label: "Messages", icon: MessageSquare },
  // Consultation ponctuelle : gardée en dernier, hors des raccourcis quotidiens.
  { to: "/traceability", label: "Traçabilité", icon: ScanLine },
];

export function Header() {
  const { client, logout } = usePortalAuth();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return (
    <header className="sticky top-0 z-20 bg-cream/95 backdrop-blur border-b border-border">
      <div className="max-w-5xl mx-auto flex items-center justify-between px-4 py-3">
        <Link to="/dashboard" className="flex items-center gap-2">
          <span className="font-display text-xl font-bold text-terracotta">Antò</span>
          <span className="hidden sm:inline text-sm text-muted">— Espace client</span>
        </Link>
        {client && (
          <div className="flex items-center gap-3">
            <Link
              to="/profile"
              className="flex items-center gap-2 text-sm text-ink hover:text-terracotta"
              aria-label="Mon profil"
            >
              <User size={18} />
              <span className="hidden sm:inline truncate max-w-[180px]">{client.name}</span>
            </Link>
            <button
              onClick={() => {
                logout();
                navigate("/");
              }}
              className="text-muted hover:text-danger"
              aria-label="Se déconnecter"
            >
              <LogOut size={18} />
            </button>
          </div>
        )}
      </div>
      {client && (
        <nav className="max-w-5xl mx-auto flex items-center gap-1 px-2 pb-2 overflow-x-auto">
          {NAV_LINKS.map(({ to, label, icon: Icon }) => (
            <Link
              key={to}
              to={to}
              aria-current={pathname === to ? "page" : undefined}
              className={`flex items-center gap-1.5 whitespace-nowrap rounded-lg px-3 py-1.5 text-sm transition-colors ${
                pathname === to
                  ? "bg-terracotta/10 text-terracotta font-semibold"
                  : "text-muted hover:text-terracotta"
              }`}
            >
              <Icon size={16} />
              {label}
            </Link>
          ))}
        </nav>
      )}
    </header>
  );
}
